import React, { useEffect, useState } from "react";
import { Plus, PencilSimple, Trash, X, Star } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "../../lib/api";

const EMPTY = { name: "", location: "", rating: 5, message: "", avatar: "", published: true };

export default function AdminTestimonials() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api.get("/admin/testimonials").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      if (editing.id) await api.put(`/admin/testimonials/${editing.id}`, editing);
      else await api.post("/admin/testimonials", editing);
      toast.success("Saved"); setEditing(null); load();
    } catch { toast.error("Save failed"); }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete?")) return;
    await api.delete(`/admin/testimonials/${id}`); load();
  };

  return (
    <div data-testid="admin-testimonials">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="h2 text-[#0A1F15]">Testimonials</h1>
          <p className="text-[#5C7368]">{items.length} reviews</p>
        </div>
        <button onClick={() => setEditing({...EMPTY})} className="btn-primary !py-2.5 text-sm">
          <Plus weight="bold" size={16}/> New
        </button>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {items.map(t => (
          <div key={t.id} className="bg-white rounded-2xl p-6 border border-[#E5E3DB]">
            <div className="flex gap-1 mb-3">
              {[...Array(t.rating || 5)].map((_, i) => <Star key={i} weight="fill" size={14} className="text-[#FDB813]"/>)}
            </div>
            <p className="text-[#2D4739] mb-4 italic">"{t.message}"</p>
            <div className="flex items-center justify-between">
              <div>
                <div className="font-semibold text-[#0A1F15]">{t.name}</div>
                <div className="text-xs text-[#5C7368]">{t.location}</div>
              </div>
              <div className="flex gap-1">
                <button onClick={() => setEditing(t)} className="p-1.5 rounded border border-[#E5E3DB] hover:bg-[#F9F8F6]"><PencilSimple size={14}/></button>
                <button onClick={() => remove(t.id)} className="p-1.5 rounded border border-red-200 text-red-600 hover:bg-red-50"><Trash size={14}/></button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <form onSubmit={save} className="bg-white rounded-2xl w-full max-w-lg">
            <div className="flex items-center justify-between p-5 border-b border-[#E5E3DB]">
              <h2 className="h3">{editing.id ? "Edit" : "New"} testimonial</h2>
              <button type="button" onClick={() => setEditing(null)} className="p-2 rounded hover:bg-[#F0EFEB]"><X size={20}/></button>
            </div>
            <div className="p-5 space-y-4">
              <F label="Name"><input required value={editing.name} onChange={e => setEditing({...editing,name:e.target.value})} className="inp"/></F>
              <F label="Location"><input required value={editing.location} onChange={e => setEditing({...editing,location:e.target.value})} className="inp"/></F>
              <F label="Rating (1-5)"><input type="number" min={1} max={5} value={editing.rating} onChange={e => setEditing({...editing,rating:Number(e.target.value)})} className="inp"/></F>
              <F label="Message"><textarea required rows={4} value={editing.message} onChange={e => setEditing({...editing,message:e.target.value})} className="inp resize-none"/></F>
              <label className="flex items-center gap-2"><input type="checkbox" checked={editing.published} onChange={e => setEditing({...editing,published:e.target.checked})}/> Published</label>
            </div>
            <div className="p-5 border-t border-[#E5E3DB] flex justify-end gap-2">
              <button type="button" onClick={() => setEditing(null)} className="btn-outline-dark !py-2.5 text-sm">Cancel</button>
              <button className="btn-primary !py-2.5 text-sm">Save</button>
            </div>
          </form>
        </div>
      )}
      <style>{`.inp{width:100%;padding:0.75rem 1rem;border-radius:0.75rem;border:1px solid #E5E3DB;background:white;}`}</style>
    </div>
  );
}
function F({label,children}){return(<div><label className="block text-xs font-bold uppercase tracking-wider text-[#5C7368] mb-1.5">{label}</label>{children}</div>);}
